import { CreativeTypes } from '@bynder-studio/render-core';
import { Creative } from 'packages/store/creatives/types';
import { type ExportResult } from './types';

export const getUniqueCreativeTypesFromDesignList = (designs: Creative[]) => {
    const uniqueCreativeTypes = new Set<CreativeTypes>();

    designs.forEach((design) => {
        if (design.creativeType) {
            uniqueCreativeTypes.add(design.creativeType);
        }
    });

    return Array.from(uniqueCreativeTypes);
};

export const getExportableDesignsFromDesignList = (designs: Creative[]) => {
    return designs.filter((design) => design.videosCount > 0);
};

export const collectAlertMessagesFromDesignList = (designs: Creative[], exportResults: ExportResult[]) => {
    const messages: string[] = [];
    const designsMap = new Map<number, Creative>();
    designs.forEach((design) => {
        designsMap.set(design.id, design);
    });

    // fist collect all designs without variations
    const designsWithoutVariations = designs.filter((design) => design.videosCount === 0);

    if (designsWithoutVariations.length === 1) {
        messages.push(
            `The design "${designsWithoutVariations[0].name}" does not have any variations. It will not be exported.`,
        );
    }

    if (designsWithoutVariations.length > 1) {
        messages.push(
            `The following designs do not have any variations: ${designsWithoutVariations
                .map((design) => `"${design.name}"`)
                .join(', ')}. They will not be exported.`,
        );
    }

    // exports errors
    exportResults.forEach((exportResult) => {
        if (exportResult.success === true) {
            return;
        }

        const design = designsMap.get(exportResult.designId);

        if (!design) {
            return;
        }

        messages.push(
            `Export of design "${design.name}" failed with error: "${exportResult.message || 'No Message'}".`,
        );
    });

    return messages.join('\n');
};
